import {Base} from "@/api/Base"

export class AnnualLeavePlanAdd extends Base {
    path = "annualLeavePlan/add"
}